import Vue from 'vue'
import Vuex from 'vuex'
import http from "@/utils/axios";
// import activity from './modules/activity';
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        searchHistry: localStorage.getItem('searchHistory') ? JSON.parse(localStorage.getItem('searchHistory')) : [],
        LOADING: true,
        histroyName: '',
        routerName: [],
        discoverHistory: localStorage.getItem('discoverHistory') ? JSON.parse(localStorage.getItem('discoverHistory')) : [], // 发现历史记录
        discount: {},
        userAfterSaleSureAddressObj: {},
        beeSureAddressObj: {},
        beeRetAddressObj: {},
        expressObj: {},
        beesBaseInfo:{}
    },
    getters: {
        getSearchHistry(state) {
            if (state.searchHistry.length) {
                return state.searchHistry;
            } else {
                return localStorage.getItem('searchHistory') ? JSON.parse(localStorage.getItem('searchHistory')) : []
            }
        },
        getDiscoverHistory(state) {
            if (state.discoverHistory.length) {
                return state.discoverHistory;
            } else {
                return localStorage.getItem('discoverHistory') ? JSON.parse(localStorage.getItem('discoverHistory')) : []
            }
        },
    },
    mutations: {
        clearDiscount(state) {
            state.discount = {}
        },
        saveDiscount(state, data) {
            state.discount = data
        },
        saveDiscountKey(state, data) {
            state.discount[data.key] = data.val
        },
        setSearchHistry(state, data) {
            state.searchHistry.push(data);
            localStorage.setItem('searchHistory', JSON.stringify(state.searchHistry))
        },
        removeHistry(state) {
            state.searchHistry = [];
            localStorage.removeItem('searchHistory');
        },
        showLoading(state) {
            state.LOADING = true
        },
        hideLoading(state) {
            state.LOADING = false
        },
        setHistryName(state, data) {
            state.histroyName = data;
        },
        setRouterName(state, data) {
            state.routerName.push(data)
        },
        removeRouterName(state, data) {
            let i = state.routerName.indexOf(data);
            state.routerName.splice(i, 1);
        },
        setDiscoverHistory(state, data) {
            state.discoverHistory.unshift(data);
            if (state.discoverHistory.length > 10) {
                state.discoverHistory = state.discoverHistory.splice(0, 10);
            }
            localStorage.setItem('discoverHistory', JSON.stringify(state.discoverHistory))
        },
        removeDiscoverHistory(state) {
            state.discoverHistory = [];
            localStorage.removeItem('discoverHistory');
        },
        setUserTrack(state, data) {
            data.tid = Math.floor(Math.random() * 987654321) + 'track';
            http({
                url: 'order/user/user/track',
                method: 'post',
                parmes: data
            }).then(rps => {})
        },
        setUserAfterSaleSureAddressData(state, data) {
            state.userAfterSaleSureAddressObj = data
        },
        setBeeSureAddressData(state, data) {
            state.beeSureAddressObj = data
        },
        setBeeRetAddressData(state, data) {
            state.beeRetAddressObj = data
        },
        setExpressObjData(state, data) {
            state.expressObj = data
        },
        setBeesBaseInfo(state){
            http({
                url: 'order/bees/bees/',
                method: 'get'
            }).then(rps => {
                state.beesBaseInfo = rps.data
            })
        }
    },
    actions: {
        clearDiscount(context) {
            context.commit('clearDiscount')
        },
        saveDiscount(context, data) {
            context.commit('saveDiscount', data)
        },
        saveDiscountKey(context, data) {
            context.commit('saveDiscountKey', data)
        },
        setSearchHistry(context, data) {
            context.commit('setSearchHistry', data)
        },
        setDiscoverHistory(context, data) {
            context.commit('setDiscoverHistory', data)
        },
        removeDiscoverHistory(context) {
            context.commit('removeDiscoverHistory')
        },
        removeHistry(context) {
            context.commit('removeHistry')
        },
        setHistryName(context, data) {
            context.commit('setHistryName', data)
        },
        setUserTrack(context, data) {
            context.commit('setUserTrack', data)
        },
        setUserAfterSaleSureAddressData(context, data) {
            context.commit('setUserAfterSaleSureAddressData', data)
        },
        setBeeSureAddressData(context, data) {
            context.commit('setBeeSureAddressData', data)
        },
        setBeeRetAddressData(context, data) {
            context.commit('setBeeRetAddressData', data)
        },
        setExpressObjData(context, data) {
            context.commit('setExpressObjData', data)
        },
        setBeesBaseInfo(context){
            context.commit('setBeesBaseInfo')
        }
    },
    modules: {
        // activity
    }
})